import { DataManagementLatest } from 'features/DataManagement/data/DataManagementLatest';

export const mockDataManagementRecord: DataManagementLatest = {
  uploadInProgress: false,
  currentUploadedFiles: [
    {
      fileType: 'OVERRIDES',
      lastModifiedTime: '02-02-2025, 13:42',
    },
    {
      fileType: 'TAGS',
      lastModifiedTime: '02-02-2025, 13:42',
    },
    {
      fileType: 'VENUE_TYPES',
      lastModifiedTime: '02-02-2025, 13:42',
    },
    {
      fileType: 'FORMAT_SIZES',
      lastModifiedTime: '02-02-2025, 13:42',
    },
  ],
};

export const mockTagResponse = [
  { id: 1, name: 'tag1' },
  { id: 2, name: 'tag2' },
  { id: 3, name: 'tag3' },
];

export const mockVenueTypeResponse = [
  { id: 1, name: 'venueType1' },
  { id: 2, name: 'venueType2' },
  { id: 3, name: 'venueType3' },
];

export const mockFormatSizeResponse = [
  { id: 1, name: 'formatSize1' },
  { id: 2, name: 'formatSize2' },
  { id: 3, name: 'formatSize3' },
];

export const mockOverrideResponse = [
  {
    space_id: 'SPACE1',
    name: 'Bank',
    media_owner_id: '1',
    media_owner_name: 'Global',
    environment: 'UndergroundStation',
    format_size_id: '1',
    latitude: '50',
    longitude: '50',
    zip: 'RM176EY',
    height: '1.65',
    width: '0.93',
    native_resolution: '1920x1080',
    consolidated_resolution: '1280x720',
    internet_access_available: 'true',
    allowed_mime_types: "['image/jpeg', 'image/png']",
    currency: 'GBP',
    average_weekly_impacts_available: '5000',
    audience_data_source: 'tfl.gov.uk',
    operating_hours: '22:00-23:59',
    venue_type_id: '30101',
    planning_rate_cpm: '15.0',
    tags: "['Sports']",
    auction_to_spot_time: 'PT30M',
  },
];

export const framesFileContent = `publisher,publisher_id,frame_id,broadsign_frame_id,player_id,player_type,name,resolution,additional_resolution,allowed_mime_types,latitude,longitude,zip,tags:id,dax_product_category,environment_code,format_size_id,width,height,enabled,venue_type_id,average_weekly_impacts_available,internet_access_available,planning_rate_cpm_gbp,operating_hours,auction_scheduling,currency,audience_data_source
  Media Owner 1,171,1,bf1,du1,Broadsign,Frame 1,Consolidated Resolution 1,Native Resolution 1,Mime Types 1,Latitude 1,Longitude 1,Zip 1,1,formatSize1,Environment 1,1,Width 1,Height 1,1,1,Weekly Impacts Available 1,Internet 1,Planning Rate Cpm 1,Operating Hours 1,TRUE,GBP,Audience Data Source 1
  Media Owner 2,171,2,bf2,du2,Broadsign,Frame 2,Consolidated Resolution 2,Native Resolution 2,Mime Types 2,Latitude 2,Longitude 2,Zip 2,2,formatSize2,Environment 2,2,Width 2,Height 2,1,2,Weekly Impacts Available 2,Internet 2,Planning Rate Cpm 2,Operating Hours 2,TRUE,GBP,Audience Data Source 2`;

export const frameGroupsFileContent = `leader_frame_id,follower_frame_id,follower_display_unit_id,follower_broadsign_frame_id
          1,3,du1,bf1
          1,4,du2,bf2
          2,5,5,`;
